import Jspdf from 'jspdf';
import { applyPlugin } from 'jspdf-autotable';

import LOGO_SLICK_PAY from 'assets/images/slickpay-logo.png';
import determinePaymentsReportPeriodText from 'bl/payment/determinePaymentsReportPeriodText.bl';
import generatePaymentsInvoiceNumber from 'bl/payment/generatePaymentsInvoiceNumber.bl';
import ELID from 'constants/elid.const';
import withOptions from 'utils/functions/withOptions.util';
import currencySign from 'utils/intl/currencySign.util';

applyPlugin(Jspdf);

const GETSLICK_EMAIL = 'accounts@getslick.com';

const generatePaymentsReport = withOptions((options) => {
  const { salonName, salonAddress, salonCity, salonPostCode, salonId, salonSign, bgn, end, total, timestamp, group, stylistName, personalStylistName, t } = options;

  const invoiceNumber = generatePaymentsInvoiceNumber({ salonId, timestamp });
  const invoicePeriod = determinePaymentsReportPeriodText({ bgn, end });
  const totalFees = currencySign({ value: Math.abs(total.fee_inc_vat), currentSalonAbbr: salonSign });

  const doc = new Jspdf('p', 'pt');
  doc.addImage(LOGO_SLICK_PAY, 'PNG', 45, 35, 290, 80); // x, y, width, height
  doc.setFontSize(12);
  doc.setTextColor('#192340');

  //  company address right text
  doc.text('Belle Newco Limited', 445, 50); // x, y
  doc.text('Northcliffe House', 462, 70);
  doc.text('Young Street', 482, 90);
  doc.text('London', 513, 110);
  doc.text('W8 5EH', 509, 130);
  if (group === 'all') {
    doc.text(t('cashUp.payoutReport.pdfPaymentReport.vatNumber'), 404, 150);
  }

  // Salon info left text
  if (group === 'single') {
    doc.text(t('cashUp.payoutReport.pdfPaymentReport.stylist', { stylist: stylistName }), 45, 240);
  } else {
    if (personalStylistName) {
      doc.text(t('cashUp.payoutReport.pdfPaymentReport.stylist', { stylist: personalStylistName }), 45, 240);
    } else {
      doc.text(`${salonName}`, 45, 200);
      doc.text(`${salonAddress}`, 45, 220);
      doc.text(`${salonCity}`, 45, 240);
      doc.text(`${salonPostCode}`, 45, 260);
    }
  }

  // invoice text
  doc.text(t('cashUp.payoutReport.pdfPaymentReport.invoiceNumber', { number: invoiceNumber }), 45, 290);
  doc.text(t('cashUp.payoutReport.pdfPaymentReport.invoicePeriod', { period: invoicePeriod }), 45, 310);
  doc.text(t('cashUp.payoutReport.pdfPaymentReport.invoiceStatus'), 45, 330);

  // Total transaction text
  doc.setTextColor('black');
  doc.setFontSize(16);
  doc.setTextColor('#192340');
  doc.text(t('cashUp.payoutReport.pdfPaymentReport.totalFees', { total: totalFees }), 45, 360);
  doc.setFontSize(12);
  doc.text(t('cashUp.payoutReport.pdfPaymentReport.description1'), 45, 390);
  doc.text(t('cashUp.payoutReport.pdfPaymentReport.description2'), 45, 410);

  const description3Text = t('cashUp.payoutReport.pdfPaymentReport.description3');
  doc.text(description3Text, 45, 430);
  const description3Width = doc.getTextWidth(description3Text);
  doc.setTextColor('blue');
  doc.text(GETSLICK_EMAIL, 45 + description3Width + 4, 430);

  doc.autoTable({
    html: document.getElementById(ELID.payoutPdfTable),
    startY: 480,
    theme: 'grid',
    font: 'helvetica',
    lineWidth: 0.5,
    fontStyle: 'normal',
    halign: 'left',
    valign: 'middle',
    fillStyle: 'F',
    columnWidth: 'auto',
    headStyles: {
      cellPadding: 6,
      fontSize: 9.4,
      fillColor: '#f6eff9',
      textColor: '#192340',
      lineColor: '#c8c7cc',
      lineWidth: 0.5,
      valign: 'middle',
    },
    styles: {
      fontSize: 10,
      cellPadding: 6,
      textColor: '#192340',
      fillColor: 255,
      lineColor: '#dfdfe0',
      valign: 'middle',
    },
  });

  return doc;
});

export default generatePaymentsReport;
